import * as React from 'react';
import Button from '../button/button';
import styles from './footer.module.css';

export const Terms: React.StatelessComponent<any> = props => {
	const hideButtons = () => {
		const iframe = (document?.querySelector('iframe') as HTMLIFrameElement);
		const parentDiv = iframe.contentWindow?.document.getElementById('dialogDiv');
		const currentDiv = parentDiv?.children[1] as HTMLElement;
		currentDiv.style.display = "none";
		if (iframe.contentWindow) {
			iframe.contentWindow.document.head.innerHTML =
				"<style>.checkClass::-webkit-scrollbar {width: 4px;} .checkClass::-webkit-scrollbar-thumb {background:  #dde1e5;;border-radius: 41px;}</style>";
			iframe.contentWindow.document.body.classList.add("checkClass");
		}
	};
	const urlToFetchTermsOfUseData = window.location.origin + '/eWMLogin/TermOfUse/TermOfUse';
	return (
		<div className="pb-3 text-lg">
			<div id="termofUse">
				<div style={{ height: '100%', width: '102%', paddingBottom: '15px', marginLeft: '-20px' }}>
					<iframe id="iframe" allowFullScreen
						height="100%" width="102%"
						src={urlToFetchTermsOfUseData}
						onLoad={() => hideButtons()}
						style={{ height: '390px' }}>
					</iframe>
				</div>
				{
					// Commented UI code for Pop-Up content since we are using content from EWM as per DE-1075, leaving code commented if future changes are needed.
				/* <div className="policy font-roboto">
					<p className="font-bold">AssetMark WEBSITE TERMS AND CONDITIONS OF USE</p>

					<p className="font-bold mt-1 underline">Legal Notices</p>
					<p>Please Read These Terms Carefully Before Using This Site</p>

					<p>
						AssetMark, Inc., AssetMark Trust Company (“AssetMark Trust”), their affiliates and subsidiaries
						(collectively "AssetMark”) provide this website (the "Site"), subject to the following Terms and
						Conditions of Use, which may be updated from time to time without notice. This Site provides you
						with certain services, including but not limited to, access to information about the products
						and services offered by AssetMark, and may provide you with information regarding other
						financial and consumer services and products offered by AssetMark and separately its affiliates
						or subsidiaries ("Affiliates") and other third party providers either directly or through
						AssetMark ("Providers"). Use of this Site and the services are subject to the Terms and
						Conditions of Use and all applicable laws. Certain areas within this Site may be subject to
						additional or different terms and conditions of use, which are posted in those areas. Not all of
						the services and materials described on this Site are available for use in all geographic areas
						of the United States or in all countries where AssetMark conducts business. By using the Site,
						you agree to abide by all of the terms and conditions set forth in this notice. Unless stated
						otherwise, any new services and materials added to this Site also will be covered by these Terms
						and Conditions of Use.
					</p>

					<p className="mt-2">
						PLEASE READ THESE TERMS CAREFULLY. IF YOU DO NOT AGREE WITH ANY OF THESE TERMS OR CONDITIONS, DO
						NOT ACCESS OR OTHERWISE USE THIS WEBSITE OR ANY INFORMATION CONTAINED ON THIS WEBSITE. YOUR
						ACCESS AND USE OF THIS WEBSITE CONSTITUTES YOUR AGREEMENT TO ABIDE BY EACH OF THE TERMS AND
						CONDITIONS SET FORTH BELOW.{' '}
					</p>

					<p className="font-bold mt-3.5 underline">Limited License</p>
					<p>
						Subject to the terms and conditions set forth in this Agreement, AssetMark grants you a
						non-exclusive, non-transferable, limited right to access, use and display this Site and the
						materials thereon. You agree not to interrupt or attempt to interrupt the operation of the Site
						in any way. AssetMark authorizes you to view and download the information ("Materials") at this
						Site only for your individual use or as is otherwise expressly permitted by your agreement(s)
						with AssetMark. This authorization is not a transfer of title in the Materials and copies of the
						Materials and is subject to the following restrictions: 1) you must retain, on all copies of the
						Materials downloaded, all copyright and other proprietary notices contained in the Materials; 2)
						you may not modify the Materials in any way or reproduce or publicly display, perform, or
						distribute or otherwise use them for any public or commercial purpose (other than for your own
						benefit or as expressly permitted by your agreement(s) with AssetMark); and 3) you must not
						transfer the Materials to any other person. You agree to abide by all additional restrictions
						displayed on the Site as it may be updated from time to time.
					</p>

					<p className="font-bold mt-3.5 underline">No Offer</p>
					<p>
						THE INFORMATION ON THIS SITE IS NOT AN OFFER BY OR ON BEHALF OF ASSETMARK OR ITS AFFILIATES TO
						SELL OR SOLICIT AN OFFER TO BUY ANY SECURITY OR OTHER SERVICES.{' '}
					</p>

					<p className="font-bold mt-3.5 underline">No Professional Advice</p>
					<p>
						Except as expressly provided in your agreement(s) with AssetMark, the information available on
						the Site is intended to be a general information resource regarding the matters covered, but is
						not offered as legal, accounting, tax or other financial advice, and is not tailored to a
						customer's specific circumstances. ALL INFORMATION, OPINIONS AND ADVICE AVAILABLE ON THIS SITE
						SHOULD BE EVALUATED IN CONSULTATION WITH A LEGAL, ACCOUNTING, TAX, INVESTMENT OR OTHER FINANCIAL
						SPECIALIST.{' '}
					</p>

					<p className="font-bold mt-3.5 underline">Copyrights/Trademarks</p>
					<p>
						This Site, including all Materials, is copyrighted and protected by worldwide copyright,
						trademark and intellectual property laws and treaty provisions. You agree to comply with all
						such laws worldwide in your use of this Site and to prevent any unauthorized copying of the
						Materials. Except as expressly provided herein, AssetMark does not grant any express or implied
						right to you under any patents, trademarks, copyrights or trade secret information. AssetMark
						and the AssetMark logo are service marks/trademarks of AssetMark, Inc.
					</p>

					<p className="font-bold mt-3.5 underline">Access, Passwords and Security</p>
					<p>
						You will be responsible for the confidentiality and use of your log in credentials and password.
						You agree not to hold AssetMark liable for any damages of any kind resulting from your decision
						to disclose your log in credentials or password to any third party, including, but not limited
						to, entities that aggregate account information or website content, or persons who are or claim
						to be acting as your agent, proxy or advisor. If you inform AssetMark or AssetMark has reason to
						believe that the security of your log in credentials or password may be or has been compromised,
						AssetMark has the right to terminate your use of this Site. You will be responsible for all
						activity conducted through and under your log in credentials or password, and any instructions
						so received by AssetMark will be deemed to have been received from you. You agree to notify
						AssetMark immediately if you become aware of any loss, theft or unauthorized use of your log in
						credentials or password.
					</p>

					<p className="font-bold mt-3.5 underline">AssetMark Trust Statements and Communications</p>

					<p>
						If you use AssetMark Trust as your custodian, you can access your AssetMark Trust statements and
						other regulatory communications in the Document Vault.
					</p>

					<p className="font-bold mt-3.5 underline">Practice Management Materials</p>

					<p>
						This Site may contain practice management and succession planning materials. These materials
						were developed by AssetMark or certain third parties at the request of AssetMark. These
						materials are for general purposes only and are not to be relied upon as legal or tax advice or
						investment advisory services. You should consult with your tax and business advisors and a
						licensed attorney. Your use of these materials does not establish any agent, advisor, broker,
						attorney-client or other special relationship between you and those who developed these
						materials. All materials are provided “as-is” with no representations, warranties or guarantees
						of any kind.
					</p>

					<p className="font-bold mt-3.5 underline">DISCLAIMER</p>

					<p>
						YOU EXPRESSLY UNDERSTAND AND AGREE THAT: (1) YOUR USE OF THIS SITE AND THE SERVICES AND
						MATERIALS PROVIDED AT THE SITE ARE AT YOUR SOLE RISK, AND (2) THE MATERIALS MAY CONTAIN
						INACCURACIES AND TYPOGRAPHICAL ERRORS. ASSETMARK, ITS AFFILIATES AND THE PROVIDERS DO NOT
						WARRANT THE ACCURACY OR COMPLETENESS OF THE MATERIALS OR THE RELIABILITY OF ANY ADVICE, OPINION,
						STATEMENT OR OTHER INFORMATION DISPLAYED OR DISTRIBUTED THROUGH THE SITE. YOU ACKNOWLEDGE THAT
						ANY RELIANCE ON THE MATERIAL OR ANY OPINION, ADVICE, STATEMENT, MEMORANDUM, OR INFORMATION SHALL
						BE AT YOUR SOLE RISK.
					</p>
					<p className="my-3.5">
						ASSETMARK, ITS AFFILIATES AND THE PROVIDERS (AS TO THEIR MATERIALS ONLY) RESERVE THE RIGHT, IN
						THEIR SOLE DISCRETION, TO CORRECT ANY ERRORS OR OMISSIONS IN ANY PORTION OF THE SITE. WE USE
						REASONABLE EFFORTS TO PROVIDE YOU WITH ACCURATE INFORMATION. WE RESERVE THE RIGHT, HOWEVER, TO
						MAKE CORRECTIONS AND/OR CHANGES SHOULD THIS INFORMATION PROVE TO BE INACCURATE. ASSETMARK , ITS
						AFFILIATES AND THE PROVIDERS (AS TO THEIR MATERIALS ONLY) MAY MAKE ANY OTHER CHANGES TO THE
						SITE, THE MATERIALS AND THE PRODUCTS, PROGRAMS, SERVICES OR PRICES (IF ANY) DESCRIBED IN THE
						SITE AT ANY TIME WITHOUT NOTICE.
					</p>
					<p className="my-3.5">
						THIS SITE, THE SERVICES, INFORMATION AND MATERIALS ON THE SITE AS WELL AS ANY SOFTWARE MADE
						AVAILABLE ON THE SITE, ARE PROVIDED "AS IS" WITHOUT ANY REPRESENTATION OR WARRANTY, EXPRESS OR
						IMPLIED, OF ANY KIND, INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY,
						NONINFRINGEMENT, OR FITNESS FOR ANY PARTICULAR PURPOSE.
					</p>
					<p className="my-3.5">
						SOME JURISDICTIONS DO NOT PERMIT THE EXCLUSION OF IMPLIED WARRANTIES. THEREFORE SOME OF THE
						EXCLUSIONS ABOVE MAY NOT APPLY TO YOU.
					</p>

					<p className="font-bold mt-3.5 underline">LIMITATION OF LIABILITY AND INDEMNIFICATION</p>
					<p>
						YOU AGREE TO INDEMNIFY AND HOLD ASSETMARK AND ITS AGENTS, EMPLOYEES, AND LICENSORS, INCLUDING
						THE PROVIDERS, HARMLESS FROM ANY CLAIM, DEMAND, LOSS, COSTS, OR EXPENSE, INCLUDING ATTORNEY'S
						FEES MADE BY ANY PERSON ARISING OUT OR YOUR VIOLATION OF THIS AGREEMENT, STATE OR FEDERAL
						SECURITIES LAWS OR REGUATIONS, OR ANY OTHER PERSON'S RIGHTS, INCLUDING BUT NOT LIMITED TO
						INFRINGEMENT OF ANY COPYRIGHT OR VIOLATION OF ANY PROPRIETARY OR PRIVACY RIGHT.
					</p>

					<p className="my-3.5">
						YOU UNDERSTAND AND AGREE THAT ASSETMARK, ITS AFFILIATES AND THE PROVIDERS WILL NOT BE LIABLE FOR
						ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES, INCLUDING, BUT
						NOT LIMITED TO, DAMAGES, COSTS OR LOSS OF PRODUCTS, USE, DATA OR OTHER INTANGIBLE LOSSES, EVEN
						IF WE HAVE BEEN ADVISED OF THE POSSIBILITIES OF THOSE DAMAGES, RESULTING FROM: (i) YOUR USE OF
						OR INABILITY TO USE THE SITE, THE SERVICES, OR MATERIALS, OR (ii) OBTAINING SUBSTITUTE PRODUCTS
						AND/OR SERVICES, OR (iii) THE USE OF ANY DATA, INFORMATION, PRODUCTS OR SERVICES OBTAINED FROM
						TRANSACTIONS ENTERED INTO THROUGH THE WEBSITE, OR (iv) ANY STATEMENT OR CONDUCT OF ANY THIRD
						PARTY, OR (v) ANY OTHER MATTER RELATED TO THE SITE, THE SERVICES OR MATERIALS.
					</p>

					<p>
						SOME JURISDICTIONS DO NOT PERMIT THE EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR
						EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES. THEREFORE, SOME OF THE
						LIMITATIONS ABOVE MAY NOT APPLY TO YOU.
					</p>

					<p className="font-bold mt-3.5 underline">Third Party Service Providers</p>
					<p>
						AssetMark may use Providers to assist in providing the Materials, with or without notice to you.
						Providers may also provide market information, including but not limited to,financial market
						data, quotes, news, analyst opinions and research reports as well ("Market Information").
						AssetMark does not endorse or approved Market Information, but makes it available to you as a
						service and convenience. AssetMark and Providers do not: (i) guarantee the accuracy, timeliness,
						completeness or correct sequencing of Market Information; or (ii) warrant any results from your
						use or reliance on Market Information. You agree that neither AssetMark nor the Providers will
						be liable to you in any way for the termination, interruption, delay, or inaccuracy of any
						Market Information. You will not redistribute or facilitate the redistribution of Market
						Information, nor will you provide access to Market Information to anyone who is not authorized
						by AssetMark to receive Market Information. You consent and authorize AssetMark to delegate the
						authorizations you provide to AssetMark, to its Providers as AssetMark deems necessary or
						desirable to provide the Materials to you. You agree that these Terms and Conditions of Use
						inure to the benefit of such Providers and that such Providers are deemed to be third party
						beneficiaries of these Terms and Conditions of Use.
					</p>

					<p className="font-bold mt-3.5 underline">Third Party Sites</p>
					<p>
						As a convenience to you, AssetMark may provide, on this Site, links to websites operated by
						other entities. If you use these sites, you will leave this Site. If you decide to visit any
						linked site, you do so at your own risk, subject to that site's terms and conditions of use and
						privacy policy that may be different from those of this Site. It is your responsibility to take
						all protective measures to guard against viruses or other destructive elements you may encounter
						on these sites. AssetMark makes no warranty or representation regarding, and does not endorse,
						any linked websites or the information appearing thereon or any of the products or services
						described thereon. Links do not imply that AssetMark or this Site sponsors, endorses, is
						affiliated or associated with, or accessible through the links, or that any linked site is
						authorized to use any trademark, trade name, logo or copyright symbol of AssetMark or any of its
						affiliates or subsidiaries.
					</p>

					<p className="font-bold mt-3.5 underline">External Links to the Site</p>
					<p>
						All links to the Site must be approved in writing by AssetMark, except that AssetMark consents
						to links in which: (i) the link is a text-only link containing only the name "AssetMark," (ii)
						the link "points" only to assetmark.com and not to deeper pages: (iii) the link, when activated
						by a user, displays the linked page full-screen in a fully operable and navigable browser window
						and not within a "frame" on the linked website; and (iv) the appearance, position and other
						aspects of the link may neither create the false appearance that an entity or its activities or
						products are associated with or sponsored by AssetMark nor be such as to damage or dilute the
						goodwill associated with the name and service marks/trademarks of AssetMark or its Affiliates.
						AssetMark reserves the right to revoke this consent to link at any time in its sole discretion.
					</p>

					<p className="font-bold mt-3.5 underline">Viruses</p>
					<p>
						There is always the possibility of unknowingly acquiring computer viruses on the internet and
						thus we want to warn you about infections or viral contamination on your system. It is your
						responsibility to scan any and all downloaded materials received from the internet. AssetMark
						and its Affiliates are not responsible or liable for any damage caused by viruses or related
						hazards, whether or not that virus or hazard resulted from a visit to this Site. You, and not
						AssetMark assume the entire cost of all necessary servicing, repair or correction related to
						computer viruses.
					</p>

					<p className="font-bold mt-3.5 underline">Potential Disruption of Service </p>
					<p>
						Access to this Site may from time to time be unavailable, delayed, limited or slowed due to,
						among other things:{' '}
					</p>
					<ul className="list-disc pl-4 my-3">
						<li>
							hardware failure, including among other things failures of computers (including your own
							computer), servers, networks, telecommunication lines and connections, and other electronic
							and mechanical equipment;{' '}
						</li>
						<li>
							software failure, including among other things, bugs, errors, viruses, configuration
							problems, incompatibility of systems, utilities or applications, the operation of firewalls
							or screening programs, unreadable codes, or irregularities within particular documents or
							other content;{' '}
						</li>
						<li>overload of system capacities; </li>
						<li>
							damage caused by severe weather, earthquakes, wars, insurrection, riots, civil commotion,
							act of God, accident, fire, water damage, explosion, mechanical breakdown or natural
							disasters;
						</li>
						<li>interruption (whether partial or total) of power supplies or other utility of service; </li>
						<li>strike or other stoppage (whether partial or total) of labor;</li>
						<li>
							governmental or regulatory restrictions, exchange rulings, court or tribunal orders or other
							human intervention; or{' '}
						</li>
						<li>
							any other cause (whether similar or dissimilar to any of the foregoing) whatsoever beyond
							the control of AssetMark.{' '}
						</li>
					</ul>

					<p className="font-bold mt-3.5 underline">Termination of Access </p>
					<p>
						AssetMark reserves the right to terminate, without prior notice to you, your access to this Site
						in its sole discretion, including without limitation, for overuse or abuse of this Site.{' '}
					</p>

					<p className="font-bold mt-3.5 underline">Information Provided By You</p>
					<p>
						In order to use certain Services on this Site, you may have to register. You agree to provide
						true, accurate and current information about yourself as prompted by the registration and
						application forms on this Site. If any information you provide is untrue, inaccurate, incomplete
						or not current, or if AssetMark has reasonable grounds to suspect that such information is
						untrue, inaccurate, incomplete or not current, AssetMark, in its sole discretion, has the right
						to suspend or terminate your access to the Site. Further, you agree that AssetMark will not be
						liable to you or any third party if AssetMark terminates your access to the Site, and the
						Services or Materials thereon, for any reason.
					</p>

					<p className="my-3.5">
						Except for the information you submit during the registration process, during the use of any
						service offered through this Site or password protected areas of this Site (the "Permitted
						Information"), AssetMark does not want you to, and you should not, send any confidential or
						proprietary information to AssetMark via the Site. You agree that any information or materials
						that you or individuals acting on your behalf provide to AssetMark other than the Permitted
						Information will not be considered confidential or proprietary. By providing any such
						information or materials to AssetMark, you grant to AssetMark an unrestricted, irrevocable,
						worldwide, royalty-free license to use, reproduce, display, publicly perform, transmit,
						distribute and sub-license to others such information and materials, and you further agree that
						AssetMark is free to use, and allow others to use, any ideas, concepts or know-how that you or
						individuals acting on your behalf provide to AssetMark. You further recognize that AssetMark
						does not want you to, and you warrant that you shall not, provide any information or materials
						to AssetMark that is defamatory, threatening, obscene, harassing, or otherwise unlawful, or that
						incorporates the proprietary material of another.
					</p>

					<p>
						AssetMark will use the Permitted Information in accordance with the privacy policy posted on
						this Site.
					</p>

					<p className="font-bold mt-3.5 underline">Bulletin Boards</p>
					<p>
						This Site may include bulletin boards and chat rooms ("Bulletin Boards"), which allow feedback
						to AssetMark and real-time interaction between users. AssetMark does not control the messages,
						information or files delivered to Bulletin Boards. It is a condition of your use of the Bulletin
						Boards and this website that you do not:{' '}
					</p>

					<ul className="list-disc pl-4 my-3.5">
						<li>restrict or inhibit any other user from using and enjoying the Bulletin Boards; </li>
						<li>
							post or transmit any unlawful, threatening, abusive, libelous, defamatory, obscene, vulgar,
							pornographic, profane or indecent information of any kind, including without limitation any
							transmissions constituting or encouraging conduct that would constitute a criminal offense,
							give rise to civil liability or otherwise violate any local, state, national or
							international law;{' '}
						</li>
						<li>
							post or transmit any information, software or other material which violates or infringes the
							rights of others, including material which is an invasion of privacy or publicity rights or
							which is protected by copyright, trademark or other proprietary right, or derivative works
							with respect thereto, without first obtaining permission from the owner or right holder;{' '}
						</li>
						<li>
							post or transmit any virus or any information, software or other material which contains a
							virus or other harmful component;{' '}
						</li>
						<li>
							post, or transmit or in any way exploit any information, software or other material for
							commercial purposes or which contains advertising.
						</li>
					</ul>
					<p className="my-3.5">
						You understand that AssetMark has no obligation to monitor the Bulletin Boards. However,
						AssetMark reserves the right at all times to disclose any information as necessary to satisfy
						any law, regulation or governmental request, or to edit, refuse to post or to remove any
						information or materials, in whole or in part, that in AssetMark’s sole discretion are
						objectionable or in violation of these Terms and Conditions of Use.{' '}
					</p>

					<p className="font-bold mt-3.5 underline">Notices</p>
					<p>
						Notices from AssetMark to you regarding your use of the Site, the Services and Materials will be
						made by email or regular mail, in the sole discretion of AssetMark, unless otherwise required by
						law or contract.
					</p>

					<p className="font-bold mt-3.5 underline">General Terms </p>
					<p>
						AssetMark reserves the right, at its sole discretion, to change, modify, add or remove any
						portion of these Terms and Conditions of Use in whole or in part, at any time without notice.
						You should periodically revisit this Site to review the current terms and conditions by which
						you are bound. Changes in these Terms and Conditions of Use will be effective when posted. Your
						continued use of the Site, the Services and Materials after any changes to these Terms and
						Conditions of Use are posted will be considered acceptance of the changes.
					</p>
					<p>
						AssetMark may terminate, change, suspend or discontinue any aspect of the Site, including the
						availability of any features of the Site, at any time without notice. AssetMark may also impose
						limits on certain features and services or restrict your access to all or parts of the Site
						without notice or liability. AssetMark may terminate the authorization, rights and license given
						above.
					</p>
					<p>
						The Terms and Conditions of Use constitute the entire agreement between AssetMark and you in
						connection with your use of this Site, the Services and the Materials. Any cause of action you
						may have with respect to your use of this Site, the Services or the Materials must be commenced
						within one (1) year after the claim or cause of action arises. If for any reason an arbitrator
						or a court of competent jurisdiction finds any provision of these Terms and Conditions of Use or
						portion thereof, to be unenforceable, that provision shall be enforced to the maximum extent
						permissible so as to effect the intent of these Terms and Conditions of Use, and the remainder
						of the Terms and Conditions of Use shall continue in full force and effect. In the event of
						termination, the disclaimers and limitations of liabilities set forth in the Terms and
						Conditions of Use will survive.
					</p>
					<p>
						The Terms and Conditions of Use will be deemed to include all other notices, policies,
						disclaimers and other terms contained in this Site and in other contracts that you may have
						executed with AssetMark.
					</p>

					<p className="font-bold mt-3.5 underline">International Users and Choice of Law </p>
					<p>
						This Site is controlled, operated and administered by AssetMark from its offices within the
						United States of America. AssetMark makes no representation that materials at this Site are
						appropriate or available for use at other locations outside the United States and access to them
						from territories where their contents are illegal is prohibited. You may not use the Site or
						export the Materials in violation of United States' export laws and regulations. If you access
						this Site from a location outside the United States, you are responsible for compliance with all
						local laws.
					</p>
					<p>
						This Agreement constitutes the entire agreement between AssetMark and you with respect to your
						use of this Site. Any cause of action you may have with respect to your use of this Site must
						commence within one (1) year after the claim or cause of action arises. If for any reason a
						court of competent jurisdiction finds any provision of this Agreement or portion thereof, to be
						unenforceable, that provision shall be enforced to the maximum extent permissible so as to
						affect the intent of the Agreement, and the remainder of this Agreement shall continue in full
						force and effect.
					</p>

					<p className="font-bold mt-3.5 underline">Governing Law</p>
					<p>
						These Terms and Conditions of Use shall be governed by the laws of the State of California,
						United States of America, without giving effect to its conflict of laws provisions.
					</p>
				</div> */}
			</div>
			<div className={styles.btnFlex}>
				<Button
					onClick={props.onCloseModalClick}
					name="CLOSE"
					text="CLOSE"
					disabled={false}
					className={styles.closeBtn}></Button>
				<Button
					onClick={props.onPrintModalClick}
					name="PRINT"
					text="PRINT"
					disabled={false}
					className={styles.printBtn}></Button>
			</div>
		</div>
	);
};

export default Terms;
